module.exports = __webpack_public_path__ + "img/hami_logo.e8e197ec.png";